import { Pcr } from '../../lib/types/models/pcr/pcr'
import { RejectStaffApplicationInput } from '../../lib/types/models/staff-application/staff-application-input'
import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function rejectStaffApplication(data: IdsInput<RejectStaffApplicationInput>) {
  return restApiClient
    .url(constructApiUrl(API.candidate.reject.url, null))
    .post<Pcr, IdsInput<RejectStaffApplicationInput>>(data)
}
